// The public page (martepos.com for a visitor). The receipt drawn on it stays
// Georgian in the component — the real receipt is a document and prints in
// Georgian whatever the device speaks.
export const landing = {
  'lp.docTitle': '{brand} — სალარო, საწყობი და ბუღალტერია',
  'lp.nav.till': 'სალარო',
  'lp.nav.features': 'შესაძლებლობები',
  'lp.nav.hardware': 'აპარატურა',
  'lp.nav.pricing': 'ფასი',
  'lp.nav.faq': 'კითხვები',
  'lp.navAria': 'გვერდის ნავიგაცია',
  'lp.login': 'შესვლა',
  'lp.start': 'უფასოდ დაწყება',
  'lp.menu': 'მენიუ',
  'lp.langTo': 'ენის შეცვლა: {name}',

  'lp.hero.badge': 'შექმნილია საქართველოს მაღაზიებისთვის',
  'lp.hero.h1': 'სალარო, საწყობი და ბუღალტერია ერთ სისტემაში',
  'lp.hero.h1a': 'სალარო, საწყობი და ბუღალტერია',
  'lp.hero.h1b': 'ერთ სისტემაში',
  'lp.hero.lead': '{brand} მაღაზიის ყოველდღიურ საქმეს ერთ ადგილას აგროვებს: გაყიდვა შტრიხკოდით, ჩეკი, ნაშთი, RS.GE-ს ზედნადებები, ნისია, ცვლები და მოგება. მუშაობს კომპიუტერზე, პლანშეტსა და ტელეფონზე — ინსტალაციის გარეშე.',
  'lp.trial': '14 დღე უფასოდ',
  'lp.hero.how': 'ნახე როგორ მუშაობს',
  'lp.noCard': 'საბანკო ბარათი არ გჭირდება',
  'lp.hero.then': 'შემდეგ ₾{price} თვეში — ყველაფერი ფასში',
  'lp.hero.lang': 'ქართულ ენაზე',
  'lp.photo.till': 'მოლარე სალაროსთან, პლანშეტზე გაყიდვის ეკრანით',
  'lp.float.sold': 'გაყიდვა დასრულდა',
  'lp.float.soldSub': 'ნაღდი · 3 პროდუქტი',
  'lp.float.received': 'მიღებული',
  'lp.float.change': 'ხურდა',
  'lp.float.waybill': 'RS.GE ზედნადები',
  'lp.float.waybillSub': '12 პროდუქტი · მიღებულია',

  'lp.fact1.t': 'ინტერნეტი გაითიშა?',
  'lp.fact1.s': 'გაყიდვა გრძელდება',
  'lp.fact2.t': 'RS.GE-ს ზედნადებები',
  'lp.fact2.s': 'პირდაპირ სისტემაში',
  'lp.fact3.t': 'ნებისმიერი ეკრანი',
  'lp.fact3.s': 'კომპიუტერი, პლანშეტი, ტელეფონი',
  'lp.fact4.t': 'დაცული მონაცემები',
  'lp.fact4.s': 'თითოეული მაღაზია — ცალკე',

  'lp.till.eyebrow': 'POS სალარო',
  'lp.till.h2': 'ასე გამოიყურება სალარო',
  'lp.till.p': 'მარცხნივ პროდუქტები ფოტოებით და ნაშთით, მარჯვნივ კალათა და გადახდა. შტრიხკოდის დასკანერებისას კალათა მთელ ეკრანზე იშლება, ჯამი კი შორიდანაც იკითხება.',
  'lp.till.c1.t': 'სკანერი და სასწორი',
  'lp.till.c1.s': 'შტრიხკოდი და წონის ეტიკეტი ერთი სკანირებით',
  'lp.till.c2.t': 'ხურდა თავად ითვლება',
  'lp.till.c2.s': 'მიღებული თანხა ინახება ყველა გაყიდვაზე',
  'lp.till.c3.t': 'ფასი — მფლობელის',
  'lp.till.c3.s': 'სერვერი ყველა გაყიდვის ფასს ამოწმებს',
  'lp.till.c4.t': 'offline რეჟიმი',
  'lp.till.c4.s': 'კავშირის აღდგენისას ყველაფერი იგზავნება',

  'lp.mock.aria': 'MartePOS-ის სალაროს ეკრანი: პროდუქტები მარცხნივ, კალათა და გადახდა მარჯვნივ',
  'lp.mock.search': 'სახელი ან შტრიხკოდი…',
  'lp.mock.chip1': 'ყველა',
  'lp.mock.chip2': 'დამტენები',
  'lp.mock.chip3': 'კაბელები',
  'lp.mock.chip4': 'ქეისები',
  'lp.mock.chip5': 'აუდიო',
  'lp.mock.p1': 'დამტენი 20W',
  'lp.mock.p2': 'USB-C კაბელი',
  'lp.mock.p3': 'დამცავი მინა',
  'lp.mock.p4': 'ყურსასმენი',
  'lp.mock.p5': 'სამაგრი მანქანის',
  'lp.mock.p6': 'პაუერბანკი',
  'lp.mock.p7': 'ქეისი iPhone',
  'lp.mock.p8': 'ადაპტერი',
  'lp.mock.pcs': '{n} ცალი',
  'lp.mock.cart': 'კალათა',
  'lp.mock.lines': '{n} პოზიცია',
  'lp.mock.total': 'სულ:',
  'lp.mock.cash': 'ნაღდი',
  'lp.mock.card': 'ბარათი',
  'lp.mock.credit': 'ნისია',
  'lp.mock.fiscal': 'ფისკალური ჩეკი',
  'lp.mock.sell': 'გაყიდვა',

  'lp.receipt.aria': 'ჩეკის ნიმუში, როგორც თერმული პრინტერიდან ამოდის',
  'lp.receipt.sample': 'ნიმუში',

  'lp.rsge.tax': 'შემოსავლების სამსახური',
  'lp.rsge.waybill': 'ზედნადები',
  'lp.rsge.check': 'ფორმა, PDF, შემოწმება',
  'lp.rsge.receive': 'მიღება',
  'lp.rsge.stock': 'საწყობი',
  'lp.rsge.stockSub': 'ნაშთი და ფასები',
  'lp.rsge.box': '1 ყუთი · {n} ცალი',
  'lp.rsge.category': 'კატეგორია → {c}',

  'lp.rec.eyebrow': 'ჩეკი',
  'lp.rec.h2': 'ჩეკი — ზუსტად ისე, როგორც ამოიბეჭდება',
  'lp.rec.p': 'გაყიდვის შემდეგ ერთი ღილაკი — და თერმული პრინტერი ჩეკს ბეჭდავს. მასზეა მაღაზიის რეკვიზიტები, თარიღი, ჩეკის ნომერი, მოლარე, პროდუქტები, მიღებული თანხა და ხურდა.',
  'lp.rec.c1': 'მაღაზიის სახელი, საიდენტიფიკაციო კოდი, მისამართი და ტელეფონი — შენი პარამეტრებიდან',
  'lp.rec.c2': 'აქცია, ფასდაკლება და ბონუსი ცალკე სტრიქონებად',
  'lp.rec.c3': 'ნისიაზე: რამდენი გადაიხადა და რამდენი დარჩა ვალად',
  'lp.rec.c4': 'Z-ანგარიში ნებისმიერ დახურულ ცვლაზე',

  'lp.rs.eyebrow': 'RS.GE-სთან კავშირი',
  'lp.rs.h2': 'ზედნადები RS.GE-დან — ხელით აკრეფის გარეშე',
  'lp.rs.p': 'მომწოდებლის ზედნადები {brand}-ში თავად ჩამოდის. ხედავ მას RS.GE-ს ოფიციალური ფორმით, ამოწმებ და ერთ ეკრანზე იღებ საწყობში — ახალი პროდუქტები იქვე იქმნება.',
  'lp.rs.c1': 'ზედნადები RS.GE-ს ფორმით, PDF-ად ბეჭდვით',
  'lp.rs.c2': 'ახალ პროდუქტს კატეგორიას სისტემა თავად გთავაზობს — ქართულ და ლათინურ სახელებზეც',
  'lp.rs.c3': 'ყუთი თუ ცალი — შეფუთვის ზომას სისტემა ცნობს',
  'lp.rs.c4': 'გაუქმებული ზედნადების მიღება დაბლოკილია',
  'lp.rs.onceB': 'დაკავშირება ერთხელ:',
  'lp.rs.once': '{b} RS.GE-ს კაბინეტში ქმნი სერვისის მომხმარებელს და მის მონაცემებს {brand}-ის პარამეტრებში უთითებ. ინსტრუქცია სისტემაშივეა.',

  'lp.feat.h2': 'ყველაფერი, რაც მაღაზიას ყოველდღე სჭირდება',
  'lp.feat.p': 'რვა მოდული ერთ ანგარიშში — ცალ-ცალკე პროგრამები და Excel-ის ფაილები აღარ გჭირდება.',
  'lp.feat.1.t': 'POS სალარო',
  'lp.feat.1.x': 'შტრიხკოდით გაყიდვა, ნაღდი, ბარათი ან ნისია, ფასდაკლება, გადადებული კალათები, ხურდის დათვლა და ცხელი ღილაკები.',
  'lp.feat.2.t': 'საწყობი',
  'lp.feat.2.x': 'ნაშთი ყველა ფილიალზე, კატეგორიები, ვარგისიანობის ვადები, ინვენტარიზაცია, Excel-ით იმპორტი და ექსპორტი.',
  'lp.feat.3.t': 'მომწოდებლები',
  'lp.feat.3.x': 'შესყიდვები, მომწოდებლის ვალი და გადახდები, RS.GE-ს ზედნადებები პირდაპირ სისტემაში.',
  'lp.feat.4.t': 'ნისია',
  'lp.feat.4.x': 'კლიენტის ვალი, ნაწილობრივი გადახდა და ყველა ყიდვის ისტორია — რვეულის ნაცვლად.',
  'lp.feat.5.t': 'ბუღალტერია',
  'lp.feat.5.x': 'შემოსავალი, თვითღირებულება, ნამდვილი მოგება — ქირა და ხელფასი ყოველ თვე თავად იწერება ხარჯებში. Z-ანგარიში და Excel-ი ბუღალტრისთვის.',
  'lp.feat.6.t': 'თანამშრომლები',
  'lp.feat.6.x': 'მოლარე PIN-კოდით, ცვლები, სალაროს სხვაობა, ფასდაკლების ლიმიტი. მოგებას მოლარე ვერ ხედავს.',
  'lp.feat.7.t': 'ბონუსები და აქციები',
  'lp.feat.7.x': 'ბონუსი მუდმივ მყიდველს, კომბო-შეთავაზებები და აქციის ფასები, რომლებსაც სალარო თავად ითვლის.',
  'lp.feat.8.t': 'ფილიალები',
  'lp.feat.8.x': 'რამდენიმე მაღაზია ერთ ანგარიშში: ცალკე ნაშთი და სალარო, ერთი საერთო ბუღალტერია.',

  'lp.ctl.photo': 'მაღაზიის მფლობელი და მყიდველი დახლთან',
  'lp.ctl.eyebrow': 'კონტროლი',
  'lp.ctl.h2': 'ფული, რომელიც ყოველთვის ემთხვევა',
  'lp.ctl.p': 'ცვლის დახურვისას სისტემა აჩვენებს, რამდენი უნდა იყოს სალაროში და რამდენი დათვალა მოლარემ — სხვაობა ლარებსა და თეთრებში.',
  'lp.ctl.c1': 'ფული კასიდან უკვალოდ ვერ გაქრება — ყოველი გატანა მიზეზით, დახურვისას ჩანს, რა დარჩა კასაში და სად წავიდა დანარჩენი',
  'lp.ctl.c2': 'ცვლის გახსნა და დახურვა, სალაროს სხვაობა',
  'lp.ctl.c3': 'მოლარის ფასდაკლების ლიმიტი — მეტი მხოლოდ მფლობელის PIN-კოდით',
  'lp.ctl.c4': 'მოგება, თვითღირებულება და ბუღალტერია — მხოლოდ მფლობელისთვის',
  'lp.ctl.c5': 'ყველა ნაღდ გაყიდვაზე — მიღებული კუპიურა და ხურდა',
  'lp.shift.title': 'ცვლის დახურვა',
  'lp.shift.opening': 'ცვლის საწყისი თანხა',
  'lp.shift.cash': 'ნაღდი გაყიდვები',
  'lp.shift.returns': 'ნაღდი დაბრუნებები',
  'lp.shift.expected': 'სალაროში უნდა იყოს',
  'lp.shift.counted': 'დათვლილი',
  'lp.shift.exact': 'ზუსტი',
  'lp.shift.stays': 'კასაში დარჩა',
  'lp.shift.bank': 'ბანკში შეტანილი',

  'lp.hw.h2': 'მუშაობს ტექნიკასთან, რომელიც უკვე გაქვს',
  'lp.hw.p': 'ძვირადღირებული POS-ტერმინალი არ გჭირდება. საკმარისია კომპიუტერი ან პლანშეტი — დანარჩენს შეაერთებ, როცა დაგჭირდება.',
  'lp.hw.soon': 'მალე',
  'lp.hw.1.t': 'შტრიხკოდის სკანერი',
  'lp.hw.1.x': 'USB ან Bluetooth — შეაერთე და დაასკანერე, დამატებითი პროგრამის გარეშე.',
  'lp.hw.2.t': 'ჩეკის პრინტერი',
  'lp.hw.2.x': 'თერმული ჩეკი და Z-ანგარიში პირდაპირ ბრაუზერიდან.',
  'lp.hw.3.t': 'ეტიკეტის სასწორი',
  'lp.hw.3.x': 'სალარო ეტიკეტის შტრიხკოდიდან თავად კითხულობს პროდუქტს და წონას.',
  'lp.hw.4.t': 'მყიდველის ეკრანი',
  'lp.hw.4.x': 'მეორე მონიტორზე მყიდველი ხედავს კალათას და ჯამს.',
  'lp.hw.5.t': 'თვითმომსახურება',
  'lp.hw.5.x': 'კიოსკის რეჟიმი — მყიდველი პროდუქტს თავად ასკანერებს.',
  'lp.hw.6.t': 'ფისკალური აპარატი',
  'lp.hw.6.x': 'Daisy-ს აპარატებთან ინტეგრაცია ტესტირების ეტაპზეა.',

  'lp.who.eyebrow': 'ვისთვის',
  'lp.who.h2': 'მცირე და საშუალო მაღაზიებისთვის',
  'lp.who.p': 'პირველ შესვლაზე აირჩიე მაღაზიის ტიპი — კატეგორიები მზა სახით დაგხვდება, შეცვლა ნებისმიერ დროს შეიძლება.',
  'lp.who.photo1': 'სასურსათო მაღაზიის თაროები',
  'lp.who.photo2': 'ტანსაცმლის მაღაზია',
  'lp.shop.1': 'ტელეფონის აქსესუარები',
  'lp.shop.2': 'უბნის მაღაზია',
  'lp.shop.3': '24-საათიანი მარკეტი',
  'lp.shop.4': 'ზოომაღაზია',
  'lp.shop.5': 'ავტონაწილები',
  'lp.shop.6': 'საკანცელარიო',
  'lp.shop.7': 'კოსმეტიკა',
  'lp.shop.8': 'ტანსაცმელი',
  'lp.shop.9': 'სამშენებლო',
  'lp.shop.10': 'საყოფაცხოვრებო',
  'lp.shop.11': 'ყავა / კაფე',

  'lp.steps.eyebrow': 'როგორ დავიწყოთ',
  'lp.steps.h2': 'სამი ნაბიჯი — და სალარო მზადაა',
  'lp.step.1.t': 'რეგისტრაცია',
  'lp.step.1.x': 'ელ-ფოსტა და პაროლი. დაადასტურე ბმულით, რომელიც ფოსტაზე მოგივა.',
  'lp.step.2.t': 'პროდუქტები',
  'lp.step.2.x': 'აირჩიე მზა კატეგორიები შენი მაღაზიის ტიპისთვის, შემოიტანე Excel-ი ან RS.GE-ს ზედნადები.',
  'lp.step.3.t': 'გაყიდვა',
  'lp.step.3.x': 'გახსენი ცვლა, დაამატე მოლარეები და დაიწყე — იმავე დღეს.',

  'lp.price.h2': 'ერთი ფასი — ყველაფერი შიგნით',
  'lp.price.p': 'პაკეტებად არ ვყოფთ: ყველა შესაძლებლობა ყველასთვის ჩართულია, პროდუქტი და მოლარე კი — რამდენიც გჭირდება.',
  'lp.price.one': 'ერთი მაღაზია',
  'lp.price.perMonth': '/ თვეში',
  'lp.price.year': 'ან {sum} წელიწადში — ორი თვე საჩუქრად',
  'lp.price.noSetup': 'ინსტალაციის საფასური არ არის',
  'lp.price.transfer': 'გადახდა — საბანკო გადარიცხვით',
  'lp.price.includes': 'ფასში შედის',
  'lp.price.trialLimit': 'საცდელ პერიოდში — 10 000 პროდუქტამდე; გადახდის შემდეგ ლიმიტი აღარ არის.',
  'lp.price.branchesB': 'რამდენიმე ფილიალი გაქვს?',
  'lp.price.branches': '{b} ფასი ინდივიდუალურად განისაზღვრება — ყველა ფილიალი ერთ ანგარიშში, საერთო ბუღალტერიით.',
  'lp.inc.1': 'ულიმიტო პროდუქტი',
  'lp.inc.2': 'ულიმიტო მოლარე, თითოეული — თავისი PIN-კოდით',
  'lp.inc.3': 'სალარო კომპიუტერზე, პლანშეტსა და ტელეფონზე',
  'lp.inc.4': 'RS.GE-ს ზედნადებები — მიღებაც და გამოწერაც',
  'lp.inc.5': 'ნისია, ბონუსები და აქციები',
  'lp.inc.6': 'ნაღდი, ბარათი და ნისია ერთ ჩეკზე',
  'lp.inc.7': 'ბუღალტერია, Z-ანგარიში და Excel ბუღალტრისთვის',
  'lp.inc.8': 'ბუღალტრის ცალკე შესვლა — ხედავს, ვერ ცვლის',
  'lp.inc.9': 'offline რეჟიმი',
  'lp.inc.10': 'ყველა განახლება',

  'lp.faq.h2': 'ხშირი კითხვები',
  'lp.faq.1.q': 'რა მჭირდება დასაწყებად?',
  'lp.faq.1.a': 'კომპიუტერი, პლანშეტი ან ტელეფონი და ინტერნეტი. ინსტალაცია არ სჭირდება — სისტემა ბრაუზერში მუშაობს და აპლიკაციასავით დაყენებაც შეიძლება. სკანერი და პრინტერი — სურვილისამებრ.',
  'lp.faq.2.q': 'რა მოხდება, თუ ინტერნეტი გაითიშა?',
  'lp.faq.2.a': 'სალარო მუშაობას აგრძელებს: გაყიდვები მოწყობილობაზე ინახება და კავშირის აღდგენისას თავად იგზავნება. ნისიაც იწერება — ვალი კლიენტს კავშირის აღდგენისას დაემატება. ზედნადებებს ინტერნეტი სჭირდება.',
  'lp.faq.3.q': 'რამდენ ხანს შემიძლია უფასოდ ცდა?',
  'lp.faq.3.a': '14 დღე, სრული ფუნქციონალით. საბანკო ბარათი რეგისტრაციისას არ გჭირდება.',
  'lp.faq.4.q': 'რა ღირს საცდელი პერიოდის შემდეგ?',
  'lp.faq.4.a': '₾{month} თვეში ან ₾{year} წელიწადში — ორი თვე საჩუქრად. ფასში ყველა შესაძლებლობა შედის: პაკეტებად არ ვყოფთ, პროდუქტი და მოლარე ულიმიტოა. გადახდა საბანკო გადარიცხვით ხდება; რამდენიმე ფილიალის ფასი ინდივიდუალურად განისაზღვრება.',
  'lp.faq.5.q': 'ვინ ხედავს ჩემი მაღაზიის მონაცემებს?',
  'lp.faq.5.a': 'მხოლოდ შენი მაღაზიის ანგარიშები — ყველა მაღაზიის მონაცემები ბაზის დონეზეა გამიჯნული. მოლარე მხოლოდ სალაროს ხედავს; მოგებას, თვითღირებულებას და ბუღალტერიას — მხოლოდ მფლობელი.',
  'lp.faq.6.q': 'რამდენიმე ფილიალი მაქვს — შეიძლება?',
  'lp.faq.6.a': 'კი. თითოეულ ფილიალს თავისი ნაშთი და სალარო აქვს, მოლარის მიბმა კონკრეტულ ფილიალზე შეიძლება, ბუღალტერია კი ერთ ადგილას ჩანს.',
  'lp.faq.7.q': 'როგორ დავაკავშირო RS.GE?',
  'lp.faq.7.a': 'RS.GE-ს კაბინეტში ქმნი სერვისის მომხმარებელს და მის მონაცემებს სისტემის პარამეტრებში უთითებ. ნაბიჯ-ნაბიჯ ინსტრუქცია სისტემაშივეა.',

  'lp.final.h2': 'დაიწყე დღესვე',
  'lp.final.p': '14 დღე უფასოდ, სრული ფუნქციონალით. თუ არ მოგეწონა — არაფერს იხდი.',
  'lp.createShop': 'მაღაზიის შექმნა',
  'lp.final.have': 'უკვე მაქვს ანგარიში',

  'lp.foot.about': 'სალარო, საწყობი და ბუღალტერია მცირე და საშუალო მაღაზიისთვის.',
  'lp.foot.product': 'პროდუქტი',
  'lp.foot.account': 'ანგარიში',
  'lp.foot.delete': 'ანგარიშის წაშლა',
  'lp.foot.made': 'შექმნილია საქართველოში',
} as const
